import { Component, ApplicationRef } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'document-scanner-preview-dialog',
  templateUrl: 'document-scanner-preview-dialog.html',
})
export class DocumentScannerPreviewDialog {
  public data: any;
  public deleteFunc: Function;

  constructor(
    private sanitizer: DomSanitizer,
    private applicationRef: ApplicationRef,
    public translationService: TranslationService) {

  }

  public previewCapture(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.data);
  }

  close() {
    this.applicationRef.tick();
  }

  delete() {
    this.deleteFunc();
    this.applicationRef.tick();
  }
}
